module.exports = __webpack_public_path__ + "img/img_footer_logo.3cd101cd.svg";